import { Grid } from "@mui/material";
import { TextInput, required } from "react-admin";

const SaveForm = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <TextInput
          label="Код"
          source="code"
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={required()}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput
          label="Име на английски език"
          source="nameEn"
          validate={required()}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

export default SaveForm;
